// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__MhyIQ","overflowing":"ReadFullNote_overflowing__2SmMI"};